export enum Severity {
    Info = "info",
    Error = "error",
    Success = "success",
    Warning = "warning" // TEMPORARY
}
